var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"vue-label-root",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.text)),(_vm.required)?_c('span',{staticClass:"required-asterisk"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }